/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_Title_PlaceholderInputs */

const en_common_support_title_placeholder = /** @type {(inputs: Common_Support_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief summary of your issue`)
};

const zh_common_support_title_placeholder = /** @type {(inputs: Common_Support_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简要描述你的问题`)
};

/**
* | output |
* | --- |
* | "Brief summary of your issue" |
*
* @param {Common_Support_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_title_placeholder = /** @type {((inputs?: Common_Support_Title_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_Title_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_title_placeholder(inputs)
	return zh_common_support_title_placeholder(inputs)
});
export { common_support_title_placeholder as "common.support.title_placeholder" }